import React, {useEffect, useContext} from "react";

import IconMission from "../../assets/images/aboutUs/mission.png";
import IconValues from "../../assets/images/aboutUs/values.png";
import IconVision from "../../assets/images/aboutUs/vision.png";
import Footer from "../../components/footer";
import GetInTouch from "../../components/getInTouch";
import Header from "../../components/header";
import Breadcrumbs from "../../components/breadcrumbs";
import Numbers from "../../components/numbers";
import {GlobalContext} from "../../context/global/globalContext";
import * as S from "./styles";

function AboutUs() {
  const {setBreadcrumbs} = useContext(GlobalContext);

  useEffect(() => {
    setBreadcrumbs([
      {label: "Home", path: "/"},
      {label: "About US", path: "/aboutus"},
    ]);
  }, [setBreadcrumbs]);
  return (
    <>
      <Header id="knowMore" />
      <S.Container>
        <Breadcrumbs />
        <S.PageIntro>
          <S.Subtitle>Nice to meet you!</S.Subtitle>
          <S.Title>We are Ecosystems Europe</S.Title>
          <S.Paragraph>
            Ecosystems Europe is an innovative leader in environmental technology, specializing in
            gas cleaning and aerosol filtration solutions. With nearly four decades of experience,
            our journey began in the 1980s as a small initiative in filter representation — and has
            since grown into a globally recognized company delivering high-performance, tailor-made
            systems to clients around the world.
          </S.Paragraph>
          <S.Paragraph>
            Driven by a passion for clean air and sustainable progress, we combine deep technical
            expertise with continuous research and a dynamic international mindset. Our team of
            experienced specialists works across borders, developing smarter and more effective ways
            to meet the world’s evolving air quality challenges.
            <S.Paragraph>
              Headquartered in Northwestern Europe, we’ve been early adopters of VOC reduction and
              acid gas cleaning strategies, earning a trusted reputation in the global environmental
              market. Today, we continue to set the standard for reliable, high-quality solutions —
              not just keeping up with the future, but engineering it.
            </S.Paragraph>
          </S.Paragraph>
        </S.PageIntro>

        <S.CardsContainer>
          <S.Card>
            <S.SideBar>
              <S.TopBar color="#41BA8D" />
              <S.Divider />
            </S.SideBar>
            <S.Content>
              <S.HeaderRow>
                <S.Icon src={IconVision} alt="Vision Icon" />
                <S.CardTitle color="#41BA8D">Our Vision</S.CardTitle>
              </S.HeaderRow>
              <S.CardDescription>
                To make clean air a universal reality through practical, reliable solutions that
                shape a safer, more resilient future.
              </S.CardDescription>
            </S.Content>
          </S.Card>

          <S.Card>
            <S.SideBar>
              <S.TopBar color="#2776BB" />
              <S.Divider />
            </S.SideBar>
            <S.Content>
              <S.HeaderRow>
                <S.Icon src={IconMission} alt="Mission Icon" />
                <S.CardTitle color="#2776BB">Our Mission</S.CardTitle>
              </S.HeaderRow>
              <S.CardDescription>
                To help industries protect the environment and public health by removing harmful
                gases, aerosols, and particles from the air.
              </S.CardDescription>
            </S.Content>
          </S.Card>

          <S.Card>
            <S.SideBar>
              <S.TopBar color="#00ADEF" />
              <S.Divider />
            </S.SideBar>
            <S.Content>
              <S.HeaderRow>
                <S.Icon src={IconValues} alt="Values Icon" />
                <S.CardTitle color="#00ADEF">Our Values</S.CardTitle>
              </S.HeaderRow>
              <S.CardDescription>
                Curiosity, commitment, safety, environmental responsibility, and customer focus.
              </S.CardDescription>
            </S.Content>
          </S.Card>
        </S.CardsContainer>
      </S.Container>

      <Numbers />
      <GetInTouch />
      <Footer />
    </>
  );
}

export default AboutUs;
